export default __webpack_public_path__ + "static/media/logo-wymap-1.936dcae0.png";